/*** IMPORTS FROM imports-loader ***/
var define = false;

import 'prevent-window-opener-attacks';

